// import React, { useState, useEffect } from "react";
// import "./Apply_Modal.css";
// import Modal from "react-bootstrap/Modal";
// import { Form } from "react-bootstrap";
// import Select from "react-select";
// import Success_Modal from "../success-modal/Success_Modal";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   CreateContact_Us,
//   resetContactState,
// } from "../../features/admin/contactus/contact/Slice";
// import { AllBranches } from "../../features/admin/common/Slice";

// // const Apply_Modal = ({ show, handleClose }) => {
// //   //  const branchOptions = [
// //   //     { value: "pune", label: "Pune" },
// //   //     { value: "mumbai", label: "Mumbai" },
// //   //     { value: "delhi", label: "Delhi" },
// //   //   ];

// //   const dispatch = useDispatch();
// //   const { status, error } = useSelector((state) => state.contact);
// //   const { all_branches } = useSelector((state) => state.common);

// //   const [showModal, setShowModal] = useState(false);
// //   const [formData, setFormData] = useState({
// //     name: "",
// //     email: "",
// //     mobile_number: "",
// //     branch_id: "",
// //     message: "",
// //   });

// //   useEffect(() => {
// //     if (show) {
// //       dispatch(AllBranches());
// //     }
// //   }, [show, dispatch]);

// //   const branchOptions =
// //     all_branches?.map((branch) => ({
// //       value: branch.branch_id,
// //       label: branch.branch_name,
// //     })) || [];

// //   const handleChange = (e) => {
// //     setFormData({
// //       ...formData,
// //       [e.target.name]: e.target.value,
// //     });
// //   };

// //   // Handle branch select change
// //   const handleBranchChange = (selectedOption) => {
// //     setFormData({
// //       ...formData,
// //       branch_id: selectedOption ? selectedOption.value : "",
// //     });
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     setShowModal(true);

// //     setTimeout(() => {
// //       setShowModal(false);
// //     }, 3000);
// //   };

// //   const closeSuccessModal = () => {
// //     setShowModal(false);
// //     handleClose(); // optional: close main modal also
// //   };

// const Apply_Modal = ({ show, handleClose }) => {
//   const dispatch = useDispatch();

//   // Get contact state
//   const { status, error } = useSelector((state) => state.contact);

//   // Get branches from common slice
//   const { all_branches } = useSelector((state) => state.common);

//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile_number: "",
//     branch_id: "",
//     message: "",
//   });

//   // Fetch branches when modal opens
//   useEffect(() => {
//     if (show) {
//       dispatch(AllBranches());
//     }
//   }, [show, dispatch]);

//   // Convert branches data to react-select format
//   const branchOptions =
//     all_branches?.map((branch) => ({
//       value: branch.branch_id, // Use actual branch_id from API
//       label: branch.branch_name, // Use actual branch_name from API
//     })) || [];

//   // Handle input changes
//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   // Handle branch select change
//   const handleBranchChange = (selectedOption) => {
//     setFormData({
//       ...formData,
//       branch_id: selectedOption ? selectedOption.value : "",
//     });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Dispatch the API call
//     await dispatch(CreateContact_Us(formData));
//   };

//   // Watch for successful submission
//   useEffect(() => {
//     if (status === "succeeded") {
//       setShowModal(true); // Show success modal

//       // Reset form
//       setFormData({
//         name: "",
//         email: "",
//         mobile_number: "",
//         branch_id: "",
//         message: "",
//       });

//       // Close success modal after 3 seconds
//       setTimeout(() => {
//         setShowModal(false);
//         handleClose(); // Close main modal
//         dispatch(resetContactState()); // Reset Redux state
//       }, 3000);
//     }
//   }, [status, dispatch, handleClose]);

//   useEffect(() => {
//     if (status === "failed" && error) {
//       alert(`Error: ${error}`);
//       dispatch(resetContactState());
//     }
//   }, [status, error, dispatch]);

//   const closeSuccessModal = () => {
//     setShowModal(false);
//     handleClose();
//     dispatch(resetContactState());
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       size="lg"
//       dialogClassName="career_modal"
//     >
//       <Modal.Body className="p-0">
//         <div className="row me-0 ms-0">
//           <div className="col-lg-6">
//             <div className="career_left">
//               <img
//                 src="/assets/images/apply_modal/left-img.png"
//                 alt="left-img"
//                 className="carrer_img"
//               />
//             </div>
//           </div>

//           <div className="col-lg-6">
//             <div className="form_wrapper">
//               <div className="form_header">
//                 <h4 className="form_title">Fill the Details to Apply</h4>
//                 <div className="close_div">
//                   <img
//                     src="/assets/images/apply_modal/close.png"
//                     alt="close-btn"
//                     className="close_btn"
//                     onClick={handleClose}
//                   />
//                 </div>
//               </div>

//               <Form onSubmit={handleSubmit}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter your full name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Email</Form.Label>
//                   <Form.Control
//                     type="email"
//                     placeholder="Enter your mail id"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Contact Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter your number"
//                     name="contact"
//                     value={formData.mobile_number}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>Select Branch</Form.Label>

//                   <Select
//                     options={branchOptions}
//                     placeholder="Select Branch"
//                     className="branch_select"
//                     classNamePrefix="select"
//                     onChange={handleBranchChange}
//                     value={branchOptions.find(
//                       (opt) => opt.value === formData.branch_id,
//                     )}
//                     isLoading={!all_branches || all_branches.length === 0}
//                     required
//                   />
//                 </Form.Group>

//                 <button className="continue_btn">Continue</button>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </Modal.Body>

//       <Success_Modal text_msg="Form Successfull" show={showModal} handleClose={handleClose} />
//     </Modal>
//   );
// };

// export default Apply_Modal;

import React, { useState, useEffect } from "react";
import "./Apply_Modal.css";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Select from "react-select";
import Success_Modal from "../success-modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import {
  CreateContact_Us,
  resetContactState,
} from "../../features/admin/contactus/contact/Slice";
import { AllBranches } from "../../features/admin/common/Slice";

const Apply_Modal = ({ show, handleClose }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const commonState = useSelector((state) => state.common || {});
  const { all_branches = [] } = commonState;

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(AllBranches());
  }, [dispatch]);

  useEffect(() => {
    if (show) {
      localStorage.setItem("applyModalOpen", "true");
    } else {
      localStorage.removeItem("applyModalOpen");
    }
  }, [show]);

  const branchOptions =
    all_branches?.map((branch) => ({
      value: branch.id || branch.branch_id || branch.branchId,
      label:
        branch.name || branch.branch_name || branch.branchName || branch.title,
    })) || [];

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const res = await dispatch(CreateContact_Us(data)).unwrap();

      if (res?.success) {
        setShowModal(true);
        reset();

        setTimeout(() => {
          setShowModal(false);
          handleClose();
        }, 2000);
      }
    } catch (error) {
      console.log("Contact error:", error);
    }
  };

  const closeSuccessModal = () => {
    setShowModal(false);
    handleClose();
    reset();
  };

  useEffect(() => {
    if (!show) {
      reset();
    }
  }, [show, reset]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="career_modal"
    >
      <Modal.Body className="p-0">
        <div className="row me-0 ms-0">
          <div className="col-lg-6">
            <div className="career_left">
              <img
                src="/assets/images/apply_modal/left2.jpeg"
                alt="left-img"
                className="carrer_img"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form_wrapper">
              <div className="form_header">
                <h4 className="form_title">Fill the Details to Apply</h4>
                <div className="close_div">
                  <img
                    src="/assets/images/apply_modal/close.png"
                    alt="close-btn"
                    className="close_btn"
                    onClick={handleClose}
                  />
                </div>
              </div>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your full name"
                    {...register("name", {
                      required: "Name is required",
                      minLength: {
                        value: 3,
                        message: "Name must be at least 3 characters",
                      },
                      maxLength: {
                        value: 50,
                        message: "Name cannot exceed 50 characters",
                      },
                      pattern: {
                        value: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
                        message:
                          "Name should contain only letters and single spaces",
                      },
                    })}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = value;

                      register("name").onChange(e);
                    }}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your mail id"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?:[A-Za-z]{2,})$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your number"
                    maxLength={10}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    {...register("mobile_number", {
                      required: "Mobile number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Mobile number must be exactly 10 digits",
                      },
                    })}
                  />
                  {errors.mobile_number && (
                    <small className="text-danger">
                      {errors.mobile_number.message}
                    </small>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Select Branch</Form.Label>
                  <Controller
                    name="branch_id"
                    control={control}
                    rules={{ required: "Branch is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={branchOptions}
                        placeholder="Select Branch"
                        className="branch_select"
                        classNamePrefix="select"
                        value={
                          branchOptions.find(
                            (opt) => opt.value === field.value,
                          ) || null
                        }
                        onChange={(option) =>
                          field.onChange(option?.value || "")
                        }
                        isLoading={!all_branches || all_branches.length === 0}
                      />
                    )}
                  />
                  {errors.branch_id && (
                    <small className="text-danger">
                      {errors.branch_id.message}
                    </small>
                  )}
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    maxLength={200}
                    placeholder="Enter your message"
                    {...register("message", {
                      required: "Message is required",
                      minLength: {
                        value: 10,
                        message: "Message must be at least 10 characters",
                      },
                      maxLength: {
                        value: 200,
                        message: "Message cannot exceed 200 characters",
                      },
                    })}
                  />
                  {errors.message && (
                    <small className="text-danger">
                      {errors.message.message}
                    </small>
                  )}
                </Form.Group>

                <button
                  className="continue_btn"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Continue"}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Success_Modal text_msg="Form Successfull" show={showModal} handleClose={closeSuccessModal} />
    </Modal>
  );
};

export default Apply_Modal;
